import {Routes} from "@angular/router";
import {PortfolioComponent} from "./portfolio/portfolio.component";
import {AboutComponent} from "./about/about.component";
import {ContactComponent} from "./contact/contact.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {BlogComponent} from "./blog/blog.component";
import {BlogHomeComponent} from "./blog/blog-home.component";
import {BlogItemComponent} from "./blog/blog-item.component";

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/portfolio',
        pathMatch: 'full'
    },
    {
        path: 'portfolio',
        component: PortfolioComponent
    },
    {
        path: 'about',
        component: AboutComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'blog',
        component: BlogComponent,
        children: [
            {
                path: ':id',
                component: BlogItemComponent
            },
            {
                path: '',
                component: BlogHomeComponent
            }
        ]
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
]


// WEBPACK FOOTER //
// ./src/app/routes.ts